import React, { useRef } from 'react';

/**
 * 可拖拽调整宽度的表头单元格（原生实现，不依赖第三方拖拽库）
 * 结合 Table 的 components={{ header: { cell: ResizableTitle } }} 使用，
 * 每个列通过 onHeaderCell 返回 { width, onResize }；
 * 拖拽时调用 onResize(newWidth) 更新列宽。
 */
const ResizableTitle = (props) => {
    const { onResize, width, children, ...restProps } = props;
    const thRef = useRef(null);
    const dragging = useRef(null);

    if (!width) {
        return <th {...restProps}>{children}</th>;
    }

    const onMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dragging.current = {
            startX: e.clientX,
            startW: thRef.current ? thRef.current.offsetWidth : width,
            newWidth: null,
        };
        const onMouseMove = (ev) => {
            if (!dragging.current) return;
            const delta = ev.clientX - dragging.current.startX;
            const newWidth = Math.max(dragging.current.startW + delta, 60);
            dragging.current.newWidth = newWidth;
            // 拖拽过程中直接修改 DOM 列宽，避免每次 mousemove 触发 React 重渲染，
            // 防止宽表格在拖拽时其他列跟着一起变化/抖动。
            const th = thRef.current;
            if (th) {
                th.style.width = newWidth + 'px';
                const row = th.parentElement;
                const idx = row ? Array.prototype.indexOf.call(row.children, th) : -1;
                const table = th.closest('table');
                const cols = table ? table.querySelector('colgroup') : null;
                if (cols && idx >= 0 && cols.children[idx]) {
                    cols.children[idx].style.width = newWidth + 'px';
                }
            }
        };
        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            document.body.style.userSelect = '';
            if (onResize && dragging.current && dragging.current.newWidth) {
                onResize(dragging.current.newWidth);
            }
            dragging.current = null;
        };
        document.body.style.userSelect = 'none';
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };

    return (
        <th
            ref={thRef}
            {...restProps}
            style={{ ...restProps.style, position: 'relative' }}
        >
            {children}
            <span
                className="resizable-handle"
                onMouseDown={onMouseDown}
                onClick={(e) => e.stopPropagation()}
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: 0,
                    width: 8,
                    cursor: 'col-resize',
                    zIndex: 2,
                    userSelect: 'none',
                    touchAction: 'none',
                }}
            />
        </th>
    );
};

export default ResizableTitle;